import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import "./App.css";

// Pages
import HomePage from "./components/pages/HomePage";
import Leistungen from "./components/pages/Leistungen";
import LeistungDetail from "./components/pages/LeistungDetail";
import Referenzen from "./components/pages/Referenzen";
import KontaktPage from "./components/pages/KontaktPage";
import Impressum from "./components/Impressum";
import Datenschutz from "./components/Datenschutz";

// Components
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";

// Layout wrapper for pages with Header and Footer
const PageLayout = ({ children }) => (
  <>
    <Header />
    {children}
    <Footer />
  </>
);

function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Startseite */}
            <Route path="/" element={<HomePage />} />
            
            {/* Leistungen */}
            <Route path="/leistungen" element={
              <PageLayout><Leistungen /></PageLayout>
            } />
            <Route path="/leistungen/:slug" element={
              <PageLayout><LeistungDetail /></PageLayout>
            } />
            
            {/* Referenzen */}
            <Route path="/referenzen" element={
              <PageLayout><Referenzen /></PageLayout>
            } />
            
            {/* Kontakt */}
            <Route path="/kontakt" element={
              <PageLayout><KontaktPage /></PageLayout>
            } />
            
            {/* Legal Pages */}
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<Datenschutz />} />
          </Routes>
          <Toaster />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
